/**
 * Se la categoria ha sottocategorie chiamare categorylist ifnot ProductList
 */
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { withStyles } from '@mui/styles'
import { style } from 'styles'

import { ProductsList } from '../ProductsList'
import { CategoriesList } from '../CategoriesList'

function CategoryDetails({ classes }) {
	const shop = useSelector(state => state.shop)
	const catDisplayMode = shop.profiles.ueby_categories_display_mode

	const { categoriesArray } = useSelector(state => state.products)
	const categoryParam = useParams()['*']

	const myCategory = categoriesArray.filter(c => c.ecom_url == categoryParam)[0]
	const hasChild = categoriesArray.filter(sub => sub.parent_id == myCategory.category_id)
	return (
		<div>
			{hasChild.length > 0 ? <CategoriesList /> : <ProductsList  />}
		</div>
	)
}

export default withStyles(style)(CategoryDetails)
